import type { Hub } from '@/models/registry';
import { hubStore } from '@/models/stores/hubs';
import useHub from './use-hub';

const useHubs = (): { hubs: Hub[]; hubPathIdentifier: string } => {
  const { lastHubPathIdentifier } = useHub();
  const hubs = hubStore.all;

  return { hubs, hubPathIdentifier: lastHubPathIdentifier as string };
};

export default useHubs;
